export default __webpack_public_path__ + "static/media/TzionasLogo.4ac2558a.png";